import DOMPurify from "dompurify";
import {
  ALLOWED_ATTR,
  ALLOWED_TAGS,
  ATTR_BY_TAG,
  isAllowedAttrValue,
} from "./sanitizePolicy";

/**
 * Sanitiza o HTML do post antes de renderizá-lo via dangerouslySetInnerHTML.
 * Caminho do BROWSER: usa o DOMPurify nativo (DOM do navegador), sem jsdom.
 * Para o SSR/Node use `sanitizeHtml.server.ts` (sanitize-html) — jsdom quebra
 * as funções serverless da Vercel. Defense-in-depth: mesmo o conteúdo sendo
 * autorado internamente, removemos qualquer tag/atributo fora da allowlist.
 *
 * A allowlist vive em `sanitizePolicy.ts`, compartilhada com o caminho Node.
 */

/**
 * Estreita a allowlist global por tag: `href` só em `<a>`, `colspan` só em
 * célula, e tag fora do mapa não carrega atributo nenhum. O DOMPurify só
 * aceita lista global de atributos; sem este hook o browser aceitaria o que o
 * `sanitize-html` do SSR recusa, e as duas saídas divergiriam — além de
 * afrouxar a defesa no caminho que renderiza no cliente. O DOMPurify é usado
 * apenas por este módulo, então registrar o hook global aqui é seguro.
 */
DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
  const allowedForTag = ATTR_BY_TAG[node.nodeName.toLowerCase()] ?? [];
  if (!allowedForTag.includes(data.attrName)) {
    data.keepAttr = false;
    return;
  }
  if (!isAllowedAttrValue(data.attrName, data.attrValue)) {
    data.keepAttr = false;
  }
});

export const sanitizeBlogHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
